var _linearGradient, _linearGradient2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClickupLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 40,
    viewBox: "0 0 161 40",
    width: 161,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    x2: 31.2358,
    y1: 40.2438,
    y2: 40.2438
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7612fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40ddff"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 0.68116,
    x2: 30.6097,
    y1: 21.9883,
    y2: 21.9883
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fa12e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd700"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 29.087 5.76396-4.46c3.06234 4.037 6.31594 5.8978 9.93744 5.8978 3.6022 0 6.7638-1.8388 9.6881-5.8441l5.8463 4.3525c-4.2195 5.7756-9.463 8.8272-15.5344 8.8272-6.05203 0-11.34635-3.032-15.7014-8.7734z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15.683 9.70266-10.25946 8.92994-4.74238-5.5555 15.02364-13.07702371 14.9049 13.08672371-4.7641 5.536z",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m72.8255 8.96017c0 1.93173 1.3944 3.34013 3.3069 3.34013v.0025c1.8495 0 3.2777-1.4109 3.2777-3.34263 0-1.86814-1.4282-3.27658-3.2777-3.27658-1.8471 0-3.3069 1.40844-3.3069 3.27658zm-2.1031-1.96618v24.99981h-5.7083v-24.99981zm-17.3836 25.36081c-3.5024-.0003-6.4215-1.1471-8.7888-3.4404-2.3675-2.3254-3.5344-5.3061-3.5344-8.9446 0-3.6678 1.1983-6.6827 3.5659-9.0424 2.4014-2.39137 5.321-3.56996 8.7924-3.56996 4.2824 0 8.0759 1.86569 10.2836 4.78286l-3.8636 4.0957c-1.8495-2.0002-3.8612-3.015-6.0327-3.015-1.8495 0-3.3746.6211-4.6407 1.9-1.2322 1.2788-1.8471 2.8853-1.8471 4.817 0 1.8682.6149 3.4404 1.8471 4.7193 1.2661 1.2446 2.7912 1.8657 4.6068 1.8657 2.3676 0 4.4447-1.049 6.1635-3.1128l4.0234 3.9001c-1.1039 1.4745-2.5952 2.6873-4.4447 3.636-1.8491.9511-3.8919 1.4083-6.1307 1.4085zm25.6812-18.4485v18.0872h-5.7422v-18.0872zm4.1163 15.8256c1.7817 1.7703 4.0525 2.6555 6.8751 2.6555 3.7959 0 7.0059-1.8682 8.5649-4.8831l-4.5754-2.7509c-.6487 1.4085-2.1738 2.3254-3.8273 2.3254-2.3046 0-4.0234-1.7703-4.0234-4.1617-.0201-1.0854.3884-2.1342 1.1354-2.9147.7795-.7874 1.7527-1.181 2.9534-1.181 1.6534 0 2.9195.7873 3.8273 2.3278l4.5729-2.4257c-1.5227-3.4404-4.8004-5.2743-8.5309-5.2743-2.8542 0-5.1564.8828-6.9405 2.6531s-2.6605 4.0297-2.6605 6.8148.8764 5.0469 2.629 6.8148zm35.3497 2.2619h-6.814l-5.29-7.1767-.842.7874v6.3893h-5.7059v-24.99981h5.7079v12.15511l5.384-5.2425h6.975l-7.686 7.2745zm.383-24.21449v14.81059c0 7.1425 4.931 9.8298 9.894 9.8298 4.994 0 9.894-2.6873 9.894-9.8298v-14.81059h-6.132v14.71279c0 2.6531-1.557 4.0297-3.762 4.0297-2.239 0-3.796-1.3106-3.796-4.0297v-14.71279zm33.34 5.66989c2.564 0 4.641.917 6.294 2.7509 1.653 1.8021 2.464 4.0639 2.464 6.717 0 2.6555-.842 4.9149-2.495 6.783-1.656 1.8339-3.731 2.7533-6.229 2.7533-1.98 0-3.699-.6553-5.094-1.966v8.9446h-5.742v-25.5255h5.646v1.6725c1.394-1.4109 3.113-2.1298 5.156-2.1298zm-1.102 5.3729c2.337 0 4.021 1.8021 4.021 4.1617h.003c.014 1.0949-.394 2.1524-1.138 2.9489-.746.8192-1.719 1.2128-2.886 1.2128-1.169 0-2.142-.3936-2.919-1.2128-.748-.8191-1.135-1.8021-1.135-2.9489 0-2.3596 1.718-4.1617 4.054-4.1617z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClickupLogo);
export default __webpack_public_path__ + "static/media/clickup_logo.a10847423b06992409452ce597562b55.svg";
export { ForwardRef as ReactComponent };